export default __webpack_public_path__ + "static/media/app-schedride.5329e4b6.png";